import styled, { css } from 'styled-components';

import { Text } from '@zillow/constellation';

import WizardActionFooter from 'app/shared/components/WizardActionFooter';

export const StyledFadeInText = styled(Text)`
    animation: fadeIn ease 2s;

    @keyframes fadeIn {
        0% {
            opacity:0;
        }
        100% {
            opacity:1;
        }
    }
`;

export const StyledWizardActionFooter = styled(WizardActionFooter)`
    ${props => props.nextLabel === 'Go to properties' && css`
        .nextButton {
            animation: fadeIn ease 2s;
        }
    `}

    @keyframes fadeIn {
        0% {
            opacity: 0;
        }
        100% {
            opacity: 1;
        }
    }
`;
